import { FC } from 'react';

import Page from 'components/Page';
import TableSkeleton from 'components/TableSkeleton';

import { Path } from 'components/Breadcrumbs';

type Props = {
  cols?: number;
  breadcrumbs?: Path[];
};

const EntityListPageSkeleton: FC<Props> = ({ breadcrumbs = [], cols = 5 }) => (
  <Page breadcrumbs={breadcrumbs}>
    <TableSkeleton cols={cols} />
  </Page>
);

export default EntityListPageSkeleton;
